var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarchartdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H0V18H24V17Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H2V9H7V18ZM2.88825 17.1684H6.09741V9.83159H2.88825V17.1684Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H9V5H14V18ZM9.88839 17.1759H13.1118V5.83743H9.88839V17.1759Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18H16V0H21V18ZM16.8882 17.1653H20.1118V0.834698H16.8882V17.1653Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarchartdc);
export default __webpack_public_path__ + "static/media/bar chart dọc.45f396f050e2dcaf909dc8425ed385e5.svg";
export { ForwardRef as ReactComponent };